import { render, staticRenderFns } from "./DigiStudentProfile.vue?vue&type=template&id=c4dd025a&"
import script from "./DigiStudentProfile.vue?vue&type=script&lang=js&"
export * from "./DigiStudentProfile.vue?vue&type=script&lang=js&"
import style0 from "./DigiStudentProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports